import { render, staticRenderFns } from "./selected-object-buttons-mobile.vue?vue&type=template&id=568136ca&scoped=true&"
import script from "./selected-object-buttons-mobile.vue?vue&type=script&lang=js&"
export * from "./selected-object-buttons-mobile.vue?vue&type=script&lang=js&"
import style0 from "./selected-object-buttons-mobile.vue?vue&type=style&index=0&id=568136ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568136ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
